import { QueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      // A 402 is a billing verdict, not a transient failure; retrying it only
      // repeats the refusal and keeps the page loading.
      retry: (failureCount, error) =>
        !(error instanceof AxiosError && error.response?.status === 402) &&
        failureCount < 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error) => {
        if (error instanceof AxiosError) {
          console.error('Mutation Error:', error.response?.data?.message);
        }
      },
    },
  },
})